<template>
  <div class="row">
    <aside class="col l3 push-l9 hide-on-med-and-down">
      <BasePushpin v-bind:calc-top="true">
        <BaseTableOfContents class="section">
          <li>
            <a v-bind:href="dadosPessoais.href">{{ dadosPessoais.title }}</a>
          </li>
          <li>
            <a v-bind:href="dadosDocumentacao.href">{{
              dadosDocumentacao.title
            }}</a>
          </li>
          <li>
            <a v-bind:href="dadosContato.href">{{ dadosContato.title }}</a>
          </li>
          <li>
            <a v-bind:href="dadosFormacao.href">{{ dadosFormacao.title }}</a>
          </li>
          <li>
            <a v-bind:href="dadosFuncionais.href">{{
              dadosFuncionais.title
            }}</a>
          </li>
        </BaseTableOfContents>
      </BasePushpin>
    </aside>

    <div class="col s12 l9 pull-l3">
      <BaseScrollspy>
        <DadosPessoais v-bind="dadosPessoais" class="scrollspy" />

        <DadosDocumentacao v-bind="dadosDocumentacao" class="scrollspy" />

        <DadosContato v-bind="dadosContato" class="scrollspy" />

        <DadosFormacao v-bind="dadosFormacao" class="scrollspy" />

        <DadosFuncionais v-bind="dadosFuncionais" class="scrollspy" />
      </BaseScrollspy>
    </div>
  </div>
</template>

<script>
import DadosPessoais from "./DadosPessoais.vue";
import DadosDocumentacao from "./DadosDocumentacao.vue";
import DadosContato from "./DadosContato.vue";
import DadosFormacao from "./DadosFormacao.vue";
import DadosFuncionais from "./DadosFuncionais.vue";

export default {
  name: "DadosServidor",
  components: {
    DadosPessoais,
    DadosDocumentacao,
    DadosContato,
    DadosFormacao,
    DadosFuncionais
  },
  inheritAttrs: false,
  props: {
    pessoaFisica: Object,
    detalhe: Object,
    documentacaoExtra: Object,
    endereco: Array,
    telefone: Array,
    email: Array,
    deficiencia: Array,
    dadoEscolar: Array,
    dadoFuncional: Array
  },
  computed: {
    dadosPessoais() {
      const id = "dadospessoais";
      const href = `#${id}`;
      const title = "Dados pessoais";
      const iconName = "account_box";
      const pessoaFisica = this.pessoaFisica;
      const detalhe = this.detalhe;
      const deficiencia = this.deficiencia;

      return {
        id,
        href,
        title,
        iconName,
        pessoaFisica,
        detalhe,
        deficiencia
      };
    },
    dadosDocumentacao() {
      const id = "dadosdocumentacao";
      const href = `#${id}`;
      const title = "Documentação";
      const iconName = "assignment";
      const documentacaoExtra = this.documentacaoExtra;

      return {
        id,
        href,
        title,
        iconName,
        documentacaoExtra
      };
    },
    dadosContato() {
      const id = "dadoscontato";
      const href = `#${id}`;
      const title = "Contato";
      const iconName = "person_pin";
      const pessoaFisica = this.pessoaFisica;
      const endereco = this.endereco;
      const telefone = this.telefone;
      const email = this.email;

      return {
        id,
        href,
        title,
        iconName,
        pessoaFisica,
        endereco,
        telefone,
        email
      };
    },
    dadosFormacao() {
      const id = "dadosformacao";
      const href = `#${id}`;
      const title = "Formação";
      const iconName = "school";
      const pessoaFisica = this.pessoaFisica;
      const dadosEscolares = this.dadoEscolar;

      return {
        id,
        href,
        title,
        iconName,
        pessoaFisica,
        dadosEscolares
      };
    },
    dadosFuncionais() {
      const id = "dadosfuncionais";
      const href = `#${id}`;
      const title = "Dados funcionais";
      const iconName = "work";
      const dadosFuncionais = this.dadoFuncional;

      return {
        id,
        href,
        title,
        iconName,
        dadosFuncionais
      };
    }
  }
};
</script>

<style scoped>
.scrollspy /deep/ h2 {
  font-size: 2.28rem;
  margin: 1.52rem 0 0.912rem 0;
}
.scrollspy /deep/ h3 {
  font-size: 1.64rem;
  margin: 1.0933333333rem 0 0.656rem 0;
}

.row {
  margin-bottom: 0;
}
</style>
